export function getStyles(element: Element) {
	let view = element.ownerDocument.defaultView;

	if (!view || !view.opener) {
		view = window;
	}

	return view.getComputedStyle(element);
}
